/**
 * Human labels for the detection modules the model server exposes.
 *
 * Single source of truth: the upload page (`DetectView`) and the dashboard's
 * live-camera selector (`DetectionModelSelector`) both render this list, and a
 * module renamed on one side used to disagree with the other.
 *
 * Unknown modules fall back to their raw name, so a new model server module is
 * still selectable before anyone writes a label for it.
 */
export const MODULE_LABELS: Record<string, string> = {
  'cat-pose': 'Cat Pain Assessment (FGS)',
  'dog-pose': 'Dog Pose & Behavior',
  'yolo-generic': 'Generic YOLO Detection',
  'vomit-detect': 'Vomit Analysis',
  'poop-detect': 'Poop Analysis',
  'poop-classify': 'Poop Classification',
};

export function moduleLabel(name: string): string {
  return MODULE_LABELS[name] || name;
}
